<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>弹出活动>新建活动</div>
		<div class="adContent">
			<div class="title">
				<div class="blue"></div>
				<div style="flex: 1;">弹出活动设置</div>
			</div>
			<el-form ref="form" label-width="150px" label-position="left">
				<el-form-item label="弹出活动名字">
					<el-input v-model="Adata.name" style="width: 400px;" size="small" placeholder=" 输入弹窗广告名称，不能超过20个字"
						maxlength="20" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="选择用户标签">
					<el-checkbox-group v-model="Adata.labels">
						<el-checkbox :label="i.id" v-for="i in labeldata" :key="i">{{i.labelName}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="活动时间">
					<el-date-picker v-model="Adata.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
						placeholder="选择开始时间">
					</el-date-picker>至
					<el-date-picker v-model="Adata.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
						placeholder="选择结束时间">
					</el-date-picker>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="活动样式">
					<upload v-model="Adata.url"  class="el-tabs-pane-upload"  ref="sss" style="width: 250px;" />
					<p style="font-size: 14px;color: #808080;">点击上传图片，jpg\png格式，图片小于1M</p>
				</el-form-item>
				<el-form-item label="优惠券">
					<el-button @click="dialog_quan=true" type="button" style="color: #565656;"><i
							class="el-icon-plus"></i>选择优惠券</el-button>
				</el-form-item>
				<el-form-item>
					<router-link to="/marketingAt">
						<el-button>取消</el-button>
					</router-link>
					<el-button @click="save($route.query.id);" type="primary" style="margin-left: 20px;">保存</el-button>
				</el-form-item>
			</el-form>
			<el-dialog :visible.sync="dialog_quan" width="60%">
				<div class="title" style="margin-top:-10px;">
					<div class="blue"></div>
					<div style="flex: 1;">选择优惠券</div>
					<span style="margin-left: 35%;">
						<el-button @click="dialog_quan = false">取 消</el-button>
						<el-button type="primary" @click="dialog_quan = false">确 定</el-button>
					</span>
				</div>
				<div>
					<el-table :cell-style="{'text-align':'center'}"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
						:data="couponList" tooltip-effect="dark" style="width: 100%">
						<el-table-column label="券ID">
							<template scope="scope">
								<el-radio :label="scope.row.id" v-model="Adata.couponRadio"></el-radio>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="title" label="名称"></el-table-column>
						<el-table-column prop="couponType" label="类型"></el-table-column>
						<el-table-column prop="storeNames" label="适用范围"></el-table-column>
						<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
						<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
						<el-table-column prop="useNum" label="已使用"></el-table-column>
					</el-table>
					<div class="pagescg">
						<el-pagination @size-change="handleSizeChange02" @current-change="handleCurrentChange02"
							:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
							layout="sizes, prev, pager, next, jumper" :total="query.total">
						</el-pagination>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				dialog_quan: false,
				atList: {

				},
				labeldata: {},
				couponList: [],
				query: {
					page: 1,
					size: 10,
					total: 100,
				},
				Adata: {
					id: undefined,
					startTime: '',
					endTime: '',
					name: '',
					labels: [],
					userLabelId: '',
					url: '',
					couponRadio: undefined,
				},
				addList: [],
			}
		},
		methods: {
			getUserLabel() {
				this.$http.post("dvertisement/selectLabel").then(function(res) {
					this.labeldata = res.body.data;
					if (this.$route.query.id) {
						this.Adata.id = this.$route.query.id;
						this.$http.get("dvertisement/selectActivity" + "?id=" + this.$route.query.id).then(
							function(r) {
								let a = JSON.parse(JSON.stringify(r.body.data[0]));
								this.Adata.name = a.name;
								this.Adata.userLabelId = a.userLabelId;
								this.Adata.startTime = a.startTime;
								this.Adata.endTime = a.endTime;
								this.Adata.url = a.imgurl;
								this.Adata.couponRadio = a.cid;
								this.labeldata.map(l => {
									this.Adata.userLabelId.split(',').map(ele => {
										if (ele == l.labelName) this.Adata.labels.push(l.id);
									})
								})
							});
					}
				})
			},
			getCoupon() {
				var q = "?pageNum=" + this.query.page + "&pageSize=" + this.query.size;
				this.$http.get("dvertisement/selectCoupon" + q).then(function(res) {
					this.couponList = res.body.data.data;
				})
			},
			save(id) {
				let d = {
					id: id,
					name: this.Adata.name,
					userLabelId: this.Adata.labels.toString(),
					startTime: this.Adata.startTime,
					endTime: this.Adata.endTime,
					imgurl: this.Adata.url,
					couponId: this.Adata.couponRadio,
				}
				if (d.name == "") {
					this.$message.error("名字不能为空")
				} else if (d.userLabelId == "") {
					this.$message.error("请选择用户标签")
				} else if (d.startTime == "" || d.endTime == "") {
					this.$message.error("请选择开始和结束时间")
				} else if (d.couponId == "") {
					this.$message.error("请选择优惠券")
				} else {
					this.$http.post("dvertisement/savePop", JSON.stringify(d)).then(function(res) {
						if (res.body.code == 200) {
							this.$message.success("保存成功")
							this.$router.push("/marketingAt");
						} else {
							this.$message.error(res.body.msg);
						}
					})
				}
			},
			handleSizeChange02(val) {
				this.query.size = val;
				this.getCoupon();
			},
			handleCurrentChange02(val) {
				this.query.page = val
				this.getCoupon();
			},
		},
		mounted() {
			this.getUserLabel();
			this.getCoupon();
		}
	}
</script>

<style>
	.title {
		font-size: 20px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;
		margin-top: 30px;
	}

	.blue {
		width: 5px;
		height: 15px;
		background: #409EFF;
		border-radius: 2px;
		margin-right: 8px;
		position: relative;
		top: 4px;
	}

	.el-form-item__label {
		font-size: 18px;
	}

	.uploadimg {
		width: 30%;
	}
</style>